import { auth, db } from "../../firebaseConfig"; // Make sure to import your Firebase configuration
import { doc, setDoc } from "firebase/firestore";

// Function to save form data for Section 5
export const writeDataS5 = async (formData) => {
  // console.log("Form data for Section 4: ", formData);
  const user = auth.currentUser;
  try {
    const docRef = doc(
      db,
      "Advisers",
      user.uid,
      "Application Details",
      "Accountant Details"
    );

    await setDoc(
      docRef,
      {
        ...formData,
      },
      { merge: true }
    );
    // console.log("Section 5 data successfully written to Firestore!");
  } catch (error) {
    // console.error("Error writing Section 5 data to Firestore: ", error);
  }
};
